import {XyGisLayerInfosService} from '../../core/services'

import {ServiceHub} from '../../core/ServiceHub'
import appConfig from '../../reducers/appConfig'
import LayerInfosActions from '../../core/enums/ActionTypes/LayerInfosActions'
import {IFeatureLayerInfo} from '../../core/interfaces/models'
import {IActionDispatcher, IPaylodAction} from '../../interfaces/dispatchers'

import {IStore} from '../../core/interfaces/reducers'
import {Feature, Projection} from '../../core/models'
import {Extent} from 'ol/extent'

export class AppXyGisLayerInfosService extends XyGisLayerInfosService {
  public getVectorLoadFunction(
    layerInfo: IFeatureLayerInfo,
    getStore: () => IStore,
    dispatch: (data: IPaylodAction | IActionDispatcher) => void
  ): (extent: Extent, resolution: number, projection: Projection) => Promise<Array<Feature>> {
    return (extent: Extent, resolution: number, projection: Projection) => {
      const setLoading = (loading: boolean) => {
        const loadingLayers = {...getStore().layerInfos.loadingLayers}
        if (loading) {
          loadingLayers[layerInfo.url] = true
        } else {
          delete loadingLayers[layerInfo.url]
        }
        dispatch({
          type: LayerInfosActions.SET_LOADING_LAYERS,
          payload: loadingLayers
        })
      }
      let where = layerInfo.sourceDescription.constantSqlWhere
      const filters = getStore().dataQueries[layerInfo.sourceDescription.id]
      if (filters && filters.mapDataWhere) {
        where = where + ' AND ' + filters.mapDataWhere
      }
      return new Promise((resolve, reject) => {
        setLoading(true)
        this.crudService
          .execute(layerInfo, {
            where: where,
            outFields: ['*'],
            returnGeometry: true,
            geometry: getStore().map.mapService.getExtent().getPolygon()
          })
          .then(features => {
            setLoading(false)
            resolve(features)
          })
          .catch(error => {
            console.error(error)
            resolve([])
            setLoading(false)
          })
      })
    }
  }
}
